import { render, staticRenderFns } from "./Authentification.vue?vue&type=template&id=89160706&"
import script from "./Authentification.vue?vue&type=script&lang=js&"
export * from "./Authentification.vue?vue&type=script&lang=js&"
import style0 from "./Authentification.vue?vue&type=style&index=0&id=89160706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports